import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-styled-flexboxgrid';
import { Body, Title } from '@vds/typography';
import { Line } from '@vds/lines';

import { Margin } from '../../../common/styles';
import { priceFormatAll } from '../../../common/Helpers/pricing';

const NBSFooter = (props) => {
  const nbsVo = props.data || {};
  const { balancePastDue } = (nbsVo && nbsVo?.accountLevelChargesVo) || {};
  const {
    paymentMessage = '',
    totUnpaidBalance = '',
    unbilledPayment = '',
    unbilledOCC = 0,
    charitableAmount = 0,
  } = balancePastDue || { thisMonthCharge: 0, nextMonthCharge: 0 };
  const lastBillCycleDate = nbsVo && nbsVo?.monthlyTotalsInfo && nbsVo?.monthlyTotalsInfo.previousCycleFormattedDateRange;
  const typeofTransaction = nbsVo && nbsVo?.nbsIndicators && nbsVo?.nbsIndicators.typeOfTransaction;
  let balanceLabel = '';

  if (totUnpaidBalance === '0.00') {
    balanceLabel = 'Current balance';
  }
  if (totUnpaidBalance > 0) {
    balanceLabel = 'Total unpaid balance';
  }
  if (totUnpaidBalance < 0) {
    balanceLabel = 'Total credit balance';
  }

  return (
    <div>
      <Margin top="20px">
        <Line type="primary" />
        <Margin top="8px">
          <Title size="medium" primitive="h3" bold>
            Account balance breakdown
          </Title>
        </Margin>
      </Margin>
      <Margin top="20px">
        <Row between="xs" style={{ maxWidth: '100%' }}>
          <Col sm={6} md={6} lg={6}>
            <Body size="large" primitive="p" bold>
              Last bill{' '}
            </Body>
            {typeofTransaction !== 'Y' && typeofTransaction !== 'C' && <Body size="large" primitive="p">{`(${lastBillCycleDate})`}</Body>}
          </Col>
          <Col sm={6} md={6} lg={6} style={{ textAlign: 'right' }}>
            <Body size="large" primitive="p">{`$${nbsVo?.prevBalance}`}</Body>
          </Col>
        </Row>
        {charitableAmount > 0 && (
          <Row between="xs" style={{ maxWidth: '100%', marginTop: '8px' }}>
            <Col sm={6} md={6} lg={6}>
              <Body size="large" primitive="p" bold>
                Charitable donation{' '}
              </Body>
            </Col>
            <Col sm={6} md={6} lg={6} style={{ textAlign: 'right' }}>
              <Body size="large" primitive="p">{`$${charitableAmount}`}</Body>
            </Col>
          </Row>
        )}
        <Row between="xs" style={{ maxWidth: '100%', marginTop: '8px' }}>
          <Col sm={6} md={6} lg={6}>
            <Body size="large" primitive="p" bold>
              Total paid
            </Body>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} style={{ textAlign: 'right' }}>
            <Body size="large" id="total_unbilled" primitive="p">
              {priceFormatAll(unbilledPayment)}
            </Body>
          </Col>
        </Row>
        {unbilledOCC !== '0.00' && (
          <Row between="xs" style={{ maxWidth: '100%', marginTop: '8px' }}>
            <Col sm={6} md={6} lg={6}>
              <Body size="large" primitive="p" bold>
                Billing adjustments
              </Body>
            </Col>
            <Col sm={6} md={6} lg={6} style={{ textAlign: 'right' }}>
              <Body size="large" primitive="p">{`$${unbilledOCC}`}</Body>
            </Col>
          </Row>
        )}
        <Margin top="16px">
          <Line type="secondary" />
        </Margin>
        <Margin top="8px">
          <Row between="xs" style={{ maxWidth: '100%' }}>
            <Col sm={6} md={6} lg={6}>
              <Body size="large" primitive="p" bold data-testid="balanceLabel">
                {balanceLabel}
              </Body>
            </Col>
            <Col sm={6} md={6} lg={6} style={{ textAlign: 'right' }}>
              <Body size="large" primitive="p" bold>
                {priceFormatAll(totUnpaidBalance)}
              </Body>
            </Col>
          </Row>
          <Row style={{ maxWidth: '100%', marginTop: '20px' }}>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Body size="large" primitive="p">
                {paymentMessage}
              </Body>
            </Col>
          </Row>
        </Margin>
      </Margin>
    </div>
  );
};
NBSFooter.propTypes = {
  data: PropTypes.object,
};
export default React.memo(NBSFooter);
